function getFileTypeFromUrl(url) {
  return url.split('.').pop().toLowerCase() || null;
}

export default getFileTypeFromUrl;
